import { useQuery } from "@tanstack/react-query";
import { UserProfile, UserSecurity, WorkOsWidgets } from "@workos-inc/widgets";
import { Alert } from "react-bootstrap";

import { AASpinner, useAATheme } from "@bagel-web/components";

import "@radix-ui/themes/styles.css";
import "@workos-inc/widgets/styles.css";
import { queries } from "..";

type FetchAccountWidgetToken = () => Promise<{ token: string }>;

const AccountManagement = ({
  fetchToken,
}: {
  fetchToken: FetchAccountWidgetToken;
}) => {
  const {
    isPending: isWidgetTokenPending,
    isError: isWidgetTokenError,
    data: widgetToken,
    error: widgetTokenError,
  } = useQuery({
    queryKey: queries.widgetTokenQueries.getAccountWidgetToken(),
    queryFn: fetchToken,
  });

  const { isDarkMode } = useAATheme();

  if (isWidgetTokenPending) {
    return <AASpinner />;
  }

  if (isWidgetTokenError || !widgetToken?.token) {
    return (
      <Alert variant="warning">
        {`Could not load account: ${widgetTokenError?.message || "Invalid permissions"}.`}
      </Alert>
    );
  }

  return (
    <WorkOsWidgets
      className="mt-3 d-flex flex-column gap-4"
      theme={{
        appearance: isDarkMode ? "dark" : "light",
        hasBackground: false,
      }}
    >
      <UserProfile authToken={widgetToken.token} />
      <UserSecurity authToken={widgetToken.token} />
    </WorkOsWidgets>
  );
};

export default AccountManagement;
